'use strict';

var ArctickClient = require('../../apiClient');
var util = require('util');
var client = require('../../client')

function Exchange() {
    ArctickClient.apply(this, arguments);
}

util.inherits(Exchange, ArctickClient);

Exchange.prototype.getMarketplaceCustomFields = function()
{
    var deferred = $.Deferred();
    $.ajax({
        url: '/marketplace/getInfo',
        type: 'GET',
        data: {},
        success: function (result) {
            // console.log('result.CustomFields: ', result.CustomFields);
            deferred.resolve(result.CustomFields);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log(textStatus, errorThrown);
            deferred.reject(errorThrown);
        }
    });
    return deferred.promise();
} 

Exchange.prototype.getUSDCurrencyExchange = function() 
{
    var deferred = $.Deferred();
    this.getMarketplaceCustomFields()
        .then((response) => {
            var exchangeCurrency = response.find(element => element.Name == "Current_USD_Exchange");
            
            if (
                exchangeCurrency != null && exchangeCurrency.Values.length > 0
                )
            {
                var numExchange = parseFloat(exchangeCurrency.Values[0]);
                var exchange = numExchange.toLocaleString("es", { maximumFractionDigits: 4, minimumFractionDigits: 4 });
                exchange = exchange.replace(',','.');
                deferred.resolve(exchange);
            }
        },
        (error) => {
            console.log(error);
            deferred.resolve(process.env.DEFAULT_CURRENCY_VALUE);
        }
    );

    return deferred.promise();
};

module.exports = Exchange;